import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=10f78c6b&"
import script from "./CategoriesView.vue?vue&type=script&lang=ts&"
export * from "./CategoriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports